import React from 'react';
import { useCallback } from 'react';
import { CheckBoxComponent } from '@syncfusion/ej2-react-buttons';
import { ToolbarComponent, ItemsDirective, ItemDirective } from '@syncfusion/ej2-react-navigations';
import './SchedulerComponent.css';

const SchedulerToolBar = ({ scheduleObj, setCurrentView, isTimelineView, setIsTimelineView }) => {
    const onToolbarItemClicked = (args) => {
        switch (args.item.text) {
            case 'Day':
                setCurrentView(isTimelineView ? 'TimelineDay' : 'Day');
                break;
            case 'Week':
                setCurrentView(isTimelineView ? 'TimelineWeek' : 'Week');
                break;
            case 'WorkWeek':
                setCurrentView(isTimelineView ? 'TimelineWorkWeek' : 'WorkWeek');
                break;
            case 'Month':
                setCurrentView(isTimelineView ? 'TimelineMonth' : 'Month');
                break;
            case 'Year':
                setCurrentView(isTimelineView ? 'TimelineYear' : 'Year');
                break;
            case 'Agenda':
                setCurrentView('Agenda');
                break;
            case 'New Event':
                const eventData = getEventData();
                scheduleObj.current.openEditor(eventData, 'Add', true);
                break;
            case 'New Recurring Event':
                const recEventData = getEventData();
                scheduleObj.current.openEditor(recEventData, 'Add', true, 1);
                break;
        }
    };

    const getEventData = () => {
        const date = scheduleObj.current.selectedDate;
        return {
            Id: scheduleObj.current.getEventMaxID(),
            Subject: '',
            StartTime: new Date(date.getFullYear(), date.getMonth(), date.getDate(), new Date().getHours(), 0, 0),
            EndTime: new Date(date.getFullYear(), date.getMonth(), date.getDate(), new Date().getHours() + 1, 0, 0),
            Location: '',
            Description: '',
            IsAllDay: false,
            CalendarId: 1
        };
    };

    const timelineTemplate = useCallback(() => {
        return (<div className='template'>
        <label>
          <div className='icon-child'>
            <CheckBoxComponent id='timeline_views' checked={isTimelineView} change={onChange}/>
          </div>
          <div className='text-child'>Timeline Views</div>
        </label>
      </div>);
    }, []);
    const groupTemplate = useCallback(() => {
        return (<div className='template'>
        <label>
          <div className='icon-child'>
            <CheckBoxComponent id='grouping' checked={true} change={(args) => { scheduleObj.current.group.resources = args.checked ? ['Calendars'] : []; }}/>
          </div>
          <div className='text-child'>Grouping</div>
        </label>
      </div>);
    }, []);
    const gridlineTemplate = useCallback(() => {
        return (<div className='template'>
        <label>
          <div className='icon-child'>
            <CheckBoxComponent id='timeSlots' checked={true} change={(args) => { scheduleObj.current.timeScale.enable = args.checked; }}/>
          </div>
          <div className='text-child'>Gridlines</div>
        </label>
      </div>);
    }, []);
    const autoHeightTemplate = useCallback(() => {
        return (<div className='template'>
        <label>
          <div className='icon-child'>
            <CheckBoxComponent id='row_auto_height' checked={false} change={(args) => { scheduleObj.current.rowAutoHeight = args.checked; }}/>
          </div>
          <div className='text-child'>Row Auto Height</div>
        </label>
      </div>);
    }, []);

    const onChange = (args) => {
        setIsTimelineView(args.checked);
    };

    return (
        <ToolbarComponent id='toolbarOptions' cssClass='overview-toolbar' width='100%' height={70} overflowMode='Scrollable' scrollStep={100} created={() => {}} clicked={onToolbarItemClicked}>
            <ItemsDirective>
            {/*<ItemDirective prefixIcon='e-icons e-plus' tooltipText='New Event' text='New Event' tabIndex={0}/>
            <ItemDirective prefixIcon='e-icons e-repeat' tooltipText='New Recurring Event' text='New Recurring Event' tabIndex={0}/>*/}
            <ItemDirective type='Separator'/>
            <ItemDirective prefixIcon='e-icons e-day' tooltipText='Day' text='Day' tabIndex={0}/>
            <ItemDirective prefixIcon='e-icons e-week' tooltipText='Week' text='Week' tabIndex={0}/>
            <ItemDirective prefixIcon='e-icons e-week' tooltipText='WorkWeek' text='WorkWeek' tabIndex={0}/>
            <ItemDirective prefixIcon='e-icons e-month' tooltipText='Month' text='Month' tabIndex={0}/>
            <ItemDirective prefixIcon='e-icons e-month' tooltipText='Year' text='Year' tabIndex={0}/>
            {/*<ItemDirective prefixIcon='e-icons e-agenda-date-range' tooltipText='Agenda' text='Agenda' tabIndex={0}/>
            <ItemDirective tooltipText='Timeline Views' text='Timeline Views' template={timelineTemplate}/>
            <ItemDirective type='Separator'/>
            <ItemDirective tooltipText='Grouping' text='Grouping' template={groupTemplate}/>
            <ItemDirective tooltipText='Timme Slots' text='Timme Slots' template={gridlineTemplate}/>
            <ItemDirective tooltipText='Auto Fit Rows' text='Auto Fit Rows' template={autoHeightTemplate}/>*/}
            </ItemsDirective>
        </ToolbarComponent>
    );
};

export default SchedulerToolBar;
